import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import { AiOutlineStock } from "react-icons/ai";

function Home_timeline() {
    return (
        <Container>
        <Row>
            <h1 className="project-heading" style={{ textAlign: "left" }}>
                Career <strong className="purple">Path </strong>
                </h1>
            <VerticalTimeline>

                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    contentStyle={{ background: 'rgba(39, 55, 77, 0.5)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgba(39, 55, 77, 0.5)' }}
                    date="Jan. 2026 - Feb. 2026"
                    iconStyle={{ background: 'rgb(39, 55, 77)', color: '#fff' }}
                    icon={<AiOutlineStock />}
                >
                    <h3 className="vertical-timeline-element-title" style={{ marginBottom: "8px" }}>Risk Management Intern</h3>
                    <h5 className="vertical-timeline-element-subtitle" > HKMC </h5>
                    <p style={{ textAlign: "left", lineHeight: "2" }}>
                        - Support risk management of the HKMC’s group, covering SFGS, AI project, property risk and market risk. <br />
                    </p>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    contentStyle={{ background: 'rgba(39, 55, 77, 0.5)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgba(39, 55, 77, 0.5)' }}
                    date="Aug. 2024 - Sep. 2024"
                    iconStyle={{ background: 'rgb(39, 55, 77)', color: '#fff' }}
                    icon={<AiOutlineStock />}
                >
                    <h3 className="vertical-timeline-element-title" style={{ marginBottom: "8px" }}>Consulting Analyst Intern</h3>
                    <h5 className="vertical-timeline-element-subtitle" >Frost & Sullivan </h5>
                    <p style={{ textAlign: "left", lineHeight: "2" }}>
                        - Drafting industry reports to support due diligence materials required for the IPO. <br />
                        - Conducting market research, factual verification and translation to support the development of the IPO prospectus. <br />
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    contentStyle={{ background: 'rgba(39, 55, 77, 0.5)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgba(39, 55, 77, 0.5)' }}
                    date="Jun. 2023 - Sep. 2023"
                    iconStyle={{ background: 'rgb(82, 109, 130)', color: '#fff' }}
                    icon={<AiOutlineStock />}
                >
                    <h3 className="vertical-timeline-element-title" style={{ marginBottom: "8px" }}>Data Scientist Intern</h3>
                    <h5 className="vertical-timeline-element-subtitle">KY & Company</h5>
                    <p style={{ textAlign: "left", lineHeight: "2"}}>
                        - Named Entity Recognition (NER) & Sentiment Analysis <br />
                        - Retrieval Augmented Generation (RAG) & Deployment <br />
                        - Web Scraping & Data Cleaning <br />
                    </p>
                </VerticalTimelineElement>

            </VerticalTimeline>
        </Row>
        </Container>
    );
    }

export default Home_timeline;